var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Widget, WidgetGroup } from "@easyquery/core";
/**
 * The widget responsed for rendering html content
 */
var HtmlContentWidget = /** @class */ (function (_super) {
    __extends(HtmlContentWidget, _super);
    /**
     * The default constructor.
     * @param slot The html element.
     */
    function HtmlContentWidget(slot) {
        var _this = _super.call(this, slot) || this;
        _this.contentElement = slot;
        _this.group = WidgetGroup.Result;
        return _this;
    }
    HtmlContentWidget.prototype.getWidgetType = function () {
        return 'htmlContent';
    };
    /**
     * Initialize widget.
     * @param context The context.
     * @param options The options.
     */
    HtmlContentWidget.prototype.init = function (context, options) {
        _super.prototype.init.call(this, context, options);
    };
    /**
     * Refresh widget implementation
     */
    HtmlContentWidget.prototype.refreshCore = function () {
        this.clear();
        if (!this.context.resultContent)
            return;
        this.render();
    };
    /**
     * Renders widget
     */
    HtmlContentWidget.prototype.render = function () {
        if (this.context.resultContent) {
            this.contentElement.innerHTML += this.context.resultContent;
        }
    };
    /**
     * Clears content.
     */
    HtmlContentWidget.prototype.clear = function () {
        this.contentElement.innerHTML = "";
    };
    HtmlContentWidget.prototype.destroyCore = function () {
        this.clear();
    };
    return HtmlContentWidget;
}(Widget));
export { HtmlContentWidget };
//# sourceMappingURL=html_content_widget.js.map